const ItemTypes = {
  CAT: 'cat',
};
export default ItemTypes;
